module.exports = __webpack_public_path__ + "static/media/All Research.b5d33b9a.png";